import React, { ReactElement } from "react";
// eslint-disable-next-line no-restricted-imports
import { Form, InputGroup, Overlay, Popover } from "banco-components";
import { sentenceCase } from "change-case";
import { ControllerProps, useFormContext } from "react-hook-form";
import { get } from "lodash";

export interface FormControllerWrapperProps {
    fieldName: string
    children?: ReactElement
    formLabel?: string | ReactElement
    noLabel?: boolean
    showFeedback?: boolean
    prependSymbol?: string
    showCharCounter?: boolean
    charCountProps?: {
        charCount: number
        maxLength: number
    }
    helpText?: string | ReactElement
    additionalClasses?: string
    popoverContent?: string | ReactElement
    isDisabled?: boolean
    controllerProps?: Pick<ControllerProps, "rules">;
    inputRef?: React.RefObject<HTMLInputElement>;
}

export const FormControllerWrapper = ({
  fieldName,
  children,
  formLabel,
  noLabel,
  showFeedback,
  prependSymbol,
  showCharCounter,
  charCountProps,
  helpText,
  additionalClasses = "",
  popoverContent,
  isDisabled,
}: FormControllerWrapperProps) => {
  const formMethods = useFormContext();
  const err = get(formMethods.formState.errors, fieldName);

  const popover = popoverContent && (
    <Popover id={ `${fieldName}-popover` }>
      <Popover.Content>{ popoverContent }</Popover.Content>
    </Popover>
  );

  const formattedLabel = (
    <>
      { formLabel || sentenceCase(fieldName) }
      { popover && (
        <span
          className="ml-1"
          data-fb-panel={ `${fieldName}-popover` }>
          <Overlay.Question
            overlay={ popover }
            placement="bottom-start"
            { ...(isDisabled && { trigger: ["click"], rootClose: true }) }
          />
        </span>
      ) }
    </>
  );

  return (
    <Form.Group className={ additionalClasses }>
      { !noLabel && <Form.Label
        className="d-inline-flex align-items-center"
        htmlFor={ fieldName as string }
      >{ formattedLabel }</Form.Label> }
      <InputGroup>
        { prependSymbol && (
          <InputGroup.Prepend>
            <InputGroup.Text>{ prependSymbol }</InputGroup.Text>
          </InputGroup.Prepend>
        ) }
        { children }
        { showFeedback &&
        <Form.Control.Feedback type="invalid" data-fb-panel={ `${fieldName}-feedback` }>
          { err?.message as string }
        </Form.Control.Feedback> }
      </InputGroup>
      { showCharCounter && charCountProps &&
      <div data-fb-panel="char-count" id="char-counter" className="d-flex justify-content-end">
        <span id="char-count" data-fb-panel="text_area_char_count">
          { charCountProps.charCount }</span>
        <span id="char-max" data-fb-panel="text_area_max_length">
          /{ charCountProps.maxLength }</span>
      </div>
      }
      { helpText && <small>{ helpText }</small> }
    </Form.Group>
  );
};
